var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"text-area section-padding"},[_c('div',{staticClass:"container container-xl"},[_c('TextContent')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }